<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-row align-v="center" align-h="center" class="mt-2" no-gutters>
          <b-col>
            <b-form-group label="이미지 제목">
              <b-input-group size="sm">
                <b-form-input type="text"/>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
          <b-col>
            <b-form-group label="이미지 설명">
              <quill-editor class="bubble"
                            ref="myTextEditorBubble"
                            v-model="contentBubble"
                            :options="editorOptionBubble"
                            @change="onEditorChange($event)">
              </quill-editor>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center" class="mt-1" no-gutters>
          <b-col>
            <b-form-group label="이미지(최대 4개)">
<!--              <b-form-row>-->
                <sortable-file-uploader :compact="false" :max-files="4"></sortable-file-uploader>
<!--              </b-form-row>-->
            </b-form-group>
          </b-col>
        </b-row>

      </b-colxx>
    </b-row>
  </div>
</template>

<script>
    import 'vue-select/dist/vue-select.css'
    import SortableFileUploader from "../../../../components/Upload/SortableFileUploader.vue";

    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'

    export default {
        components: {
            'sortable-file-uploader': SortableFileUploader,
            'quill-editor' : quillEditor
        },
        data () {
            return {
                content: '',
                editorOption: {
                    placeholder: '',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                            [
                                { list: 'ordered' },
                                { list: 'bullet' },
                                { indent: '-1' },
                                { indent: '+1' }
                            ],
                            ['link', 'image'],
                            ['clean']
                        ]
                    }
                },
                contentBubble: '',
                editorOptionBubble: {
                    theme: 'bubble',
                    placeholder: '',
                    modules: {
                        toolbar: [
                            [
                                'bold',
                                'italic',
                                'link',
                                { header: 1 },
                                { header: 2 },
                                'blockquote'
                            ]
                        ]
                    }
                }
            }
        },
        methods: {
            onEditorChange ({ editor, html, text }) {
                // console.log('editor change!', editor, html, text)
                this.contentBubble = html
            }
        }
    }
</script>
